import React, { createContext, useContext } from "react";

interface DemoModeContextValue {
  isDemoMode: boolean;
  /** True only when admin opened ?demo=true — mock/empty data should be shown.
   *  False for profile.is_demo users — they see real data, just plan-gating is simulated. */
  isAdminPreview: boolean;
  demoProducts: string[];
}

const DemoModeContext = createContext<DemoModeContextValue>({
  isDemoMode: false,
  isAdminPreview: false,
  demoProducts: ["360"],
});

// eslint-disable-next-line react-refresh/only-export-components
export function useDemoMode() {
  return useContext(DemoModeContext);
}

/** Un solo producto (.360): la lista es constante, fuera del render. */
const DEMO_PRODUCTS = ["360"];

export function DemoModeProvider({
  children,
  isAdminPreview = false,
}: {
  children: React.ReactNode;
  isAdminPreview?: boolean;
}) {
  return (
    <DemoModeContext.Provider
      value={{ isDemoMode: true, isAdminPreview, demoProducts: DEMO_PRODUCTS }}
    >
      {children}
    </DemoModeContext.Provider>
  );
}
